import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import React from 'react'

import { TestimonialRecordFieldsFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import TestimonialCard from './Card'
import { Container } from './styles'

type Props = {
  data?: TestimonialRecordFieldsFragment[]
}

function TestimonialGallery({ data }: Props) {
  if (!data) return null

  return (
    <Container
      alignItems={['center', 'center', 'center', 'center', 'unset']}
      flexDirection={['column', 'column', 'column', 'column', 'row']}
      gap={[6, 6, 6, 6, 13]}
    >
      {data.map(item => (
        <TestimonialCard data={item} key={item.id} />
      ))}
    </Container>
  )
}

export default TestimonialGallery
